<template>
  <v-row>
    <v-col cols="12" :md="8" :sm="7">
      <PostList
        action="post/getPostCourse"
        :postType="POST_TYPE_COURSE_POST"
        :courseId="course.id"
        :canCreatePost="isCourseAdmin"
        isGolfCourse
        :typeShowText="{name: course.name, type: 'course'}"
      />
    </v-col>
    <v-col cols="12" :md="4" :sm="5">
      <DrawerRight />
    </v-col>
  </v-row>
</template>

<script>
import DrawerRight from "@/components/DrawerRight";
import PostList from "@/components/Post/PostList";
export default {  
  name: "CoursesHome",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        },
      ],
    };
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  components: {
    DrawerRight,
    PostList,
  },
  beforeDestroy() {
    let vm = this;
    //reset golf course detail
    vm.$store.commit("setCourseDetail", {});
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    metaTitle() {
      const binder = {
      
          rankNumber:
            this.course && this.course.countryRank
              ? this.course.countryRank
              : "",
          courseName: this.course && this.course.name ? this.course.name : "",
      }
      const translated = this.$gettext("Ranked %{rankNumber} - %{courseName} - golf course");
      return this.$gettextInterpolate(translated, binder);
    },
    metaDescription() {
      const binder = {
          courseName: this.course && this.course.name ? this.course.name : "",
          rankNumber:
            this.course && this.course.countryRank
              ? this.course.countryRank
              : "",
          countryName:
            this.course && this.course.country.name
              ? this.course.country.name
              : "",
      }
      const translated = this.$gettext("%{courseName} ranked %{rankNumber} in %{countryName}, Discover everything about %{courseName} Golf courses. Check all the Golf courses at %{courseName}");
      return this.$gettextInterpolate(translated, binder);
    },
  },
};
</script>